import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';
import { FaBars } from 'react-icons/fa';

const AdminLayout = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const isAdmin = localStorage.getItem('adminUser');
        if (!isAdmin) {
            navigate('/admin/login');
        }
    }, [navigate]);

    const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

    return (
        <div className="admin-layout">
            <AdminSidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

            <main className="admin-main-content">
                <header className="admin-topbar d-lg-none">
                    <button className="menu-toggle" onClick={toggleSidebar}>
                        <FaBars />
                    </button>
                    <span className="topbar-title">AL-WASEEQ ADMIN</span>
                </header>

                <div className="admin-content-inner">
                    <Outlet />
                </div>
            </main>

            <style>{`
                .admin-layout {
                    display: flex;
                    min-height: 100vh;
                    background: #050505;
                }

                .admin-main-content {
                    flex: 1;
                    margin-left: 280px;
                    min-height: 100vh;
                    display: flex;
                    flex-direction: column;
                    transition: all 0.3s ease;
                }

                .admin-topbar {
                    height: 70px;
                    background: #0a0a0a;
                    display: flex;
                    align-items: center;
                    padding: 0 20px;
                    border-bottom: 1px solid rgba(255,255,255,0.05);
                }

                .menu-toggle {
                    background: none;
                    border: none;
                    color: white;
                    font-size: 1.5rem;
                    margin-right: 20px;
                }

                .topbar-title {
                    color: var(--secondary-color);
                    letter-spacing: 2px;
                    font-size: 0.8rem;
                    font-weight: 600;
                }

                .admin-content-inner {
                    flex: 1;
                    padding: 40px;
                }

                @media (max-width: 991px) {
                    .admin-main-content {
                        margin-left: 0;
                    }
                    .admin-content-inner {
                        padding: 30px 20px;
                    }
                }
            `}</style>
        </div>
    );
};

export default AdminLayout;
